function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M98.29,11.74c0-.02-.005-.039-.009-.058s0-.013,0-.019c0-.023-.01-.045-.017-.067l0-.008c-.007-.023-.015-.045-.024-.066l0-.007c-.009-.021-.018-.041-.029-.06l0-.01c-.01-.018-.021-.036-.032-.053l-.008-.013c-.011-.016-.023-.032-.035-.047l-.012-.015c-.015-.018-.031-.036-.048-.053l0,0L87.038.233,87.032.227C87.015.211,87,.2,86.98.181L86.962.167c-.015-.011-.029-.023-.045-.033L86.9.124c-.017-.01-.033-.021-.05-.03L86.839.089C86.82.079,86.8.069,86.78.061l-.008,0c-.021-.009-.043-.017-.065-.023l-.009,0c-.022-.006-.044-.012-.067-.017l-.02,0L86.555,0a.792.792,0,0,0-.079,0H60.187A4.192,4.192,0,0,0,56,4.187V49.98a4.192,4.192,0,0,0,4.187,4.187h33.92a4.192,4.192,0,0,0,4.187-4.187V11.819A.8.8,0,0,0,98.29,11.74ZM87.27,2.714l8.31,8.31H89.867a2.6,2.6,0,0,1-2.6-2.6Zm6.837,49.862H60.187a2.6,2.6,0,0,1-2.6-2.6V4.187a2.6,2.6,0,0,1,2.6-2.6H85.68V8.427a4.192,4.192,0,0,0,4.187,4.187H96.7V49.98A2.6,2.6,0,0,1,94.107,52.577Z",
  transform: "translate(-56)"
});

function SvgBlanco(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.295,
    height: 54,
    fill: "black",
    viewBox: "0 0 42.295 54.167",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlanco);
export default __webpack_public_path__ + "static/media/Blanco.27a41e93.svg";
export { ForwardRef as ReactComponent };